import './WorkingTime.scss';

import React from 'react';
import { Control, UseFormWatch } from 'react-hook-form';
import { dayjs, Dayjs } from '@esg/shared';
import { DayInWeek } from '../../constants';
import { FieldArray } from '../inputs';
import { TextCommon } from '../typo';
import { Block } from '../layouts';
import { translateCodes } from '../../locales';
import { WorkingTimeFrames } from './children';
import { IWorkingTimeItem } from '../../../business/organization/api/branch/getDetailBranch';

export interface IWorkingTimeFrame {
    isActive: boolean;
    workingTime: {
        startTime?: string;
        endTime?: string;
    };
    breakTimes: {
        startTime?: string;
        endTime?: string;
    }[];
}


export interface IBreakTimes {
    readonly startTime: Dayjs;
    readonly endTime: Dayjs;
    readonly dayOfWeek: number;
    readonly dayOfWeekTitle: string;
    readonly isFixed?: boolean;
}

export interface IDayType {
    name: string;
    key: DayInWeek;
}

const defaultOrganizationEndTime = dayjs().startOf('day').hour(22).toISOString();
const defaultOrganizationStartTime = dayjs().startOf('day').hour(8).toISOString();
const defaultOrganizationEndTimeOnly = '08:00:00';
const defaultOrganizationStartTimeOnly = '22:00:00';

export const defaultShifts: IWorkingTimeItem[] = [
    {
        isDayOff: false,
        startTime: defaultOrganizationStartTime,
        endTime: defaultOrganizationEndTime,
        dayOfWeek: DayInWeek.Monday,
        dayOfWeekTitle: 'Monday',
        breakTimes: [],
        openTime: defaultOrganizationStartTimeOnly,
        closeTime: defaultOrganizationEndTimeOnly
    },
    {
        isDayOff: false,
        startTime: defaultOrganizationStartTime,
        endTime: defaultOrganizationEndTime,
        dayOfWeek: DayInWeek.Tuesday,
        dayOfWeekTitle: 'Tuesday',
        breakTimes: [],
        openTime: defaultOrganizationStartTimeOnly,
        closeTime: defaultOrganizationEndTimeOnly
    },
    {
        isDayOff: false,
        startTime: defaultOrganizationStartTime,
        endTime: defaultOrganizationEndTime,
        dayOfWeek: DayInWeek.Wednesday,
        dayOfWeekTitle: 'Wednesday',
        breakTimes: [],
        openTime: defaultOrganizationStartTimeOnly,
        closeTime: defaultOrganizationEndTimeOnly
    },
    {
        isDayOff: false,
        startTime: defaultOrganizationStartTime,
        endTime: defaultOrganizationEndTime,
        dayOfWeek: DayInWeek.Thursday,
        dayOfWeekTitle: 'Thursday',
        breakTimes: [],
        openTime: defaultOrganizationStartTimeOnly,
        closeTime: defaultOrganizationEndTimeOnly
    },
    {
        isDayOff: false,
        startTime: defaultOrganizationStartTime,
        endTime: defaultOrganizationEndTime,
        dayOfWeek: DayInWeek.Friday,
        dayOfWeekTitle: 'Friday',
        breakTimes: [],
        openTime: defaultOrganizationStartTimeOnly,
        closeTime: defaultOrganizationEndTimeOnly
    },
    {
        isDayOff: false,
        startTime: defaultOrganizationStartTime,
        endTime: defaultOrganizationEndTime,
        dayOfWeek: DayInWeek.Saturday,
        dayOfWeekTitle: 'Saturday',
        breakTimes: [],
        openTime: defaultOrganizationStartTimeOnly,
        closeTime: defaultOrganizationEndTimeOnly
    },
    {
        isDayOff: false,
        startTime: defaultOrganizationStartTime,
        endTime: defaultOrganizationEndTime,
        dayOfWeek: DayInWeek.Sunday,
        dayOfWeekTitle: 'Sunday',
        breakTimes: [],
        openTime: defaultOrganizationStartTimeOnly,
        closeTime: defaultOrganizationEndTimeOnly
    }
];

interface WorkingTimeProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    control: Control<any>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    watch: UseFormWatch<any>;
    name: string;
    useAddBreakTime?: boolean;
    employeeId?: string;

}

export const WorkingTime = (props: WorkingTimeProps) => {
    const { control, name, watch, useAddBreakTime = true, employeeId } = props;

    return (
        <Block className='working-time'>
            <Block className={`table-header ${useAddBreakTime ? '' : 'no-break'}`} display='grid'>
                <TextCommon fontWeight='bold' textAlign='left' translateCode={translateCodes.DAY} />
                <TextCommon fontWeight='bold' textAlign='left' translateCode={translateCodes.START_TIME} />
                <TextCommon fontWeight='bold' textAlign='left' translateCode={translateCodes.FINISH_TIME} />
                <TextCommon fontWeight='bold' textAlign='left' translateCode={translateCodes.DURATION} />
            </Block>
            <Block>
                <FieldArray<IWorkingTimeItem>
                    name={name}
                    isUseWrapper={false}
                >
                    {({ fields }) => {

                        return (
                            <>
                                {fields?.map((workingTime, index) => (
                                    <Block className='table-body' key={workingTime.dayOfWeek}>
                                        <WorkingTimeFrames
                                            name={`${name}.${index}`}
                                            watch={watch}
                                            control={control}
                                            workingTime={workingTime}
                                            useAddBreakTime={useAddBreakTime}
                                            employeeId={employeeId}
                                            parentName={name}
                                        />
                                    </Block>
                                ))}
                            </>
                        );
                    }}
                </FieldArray>
            </Block>
        </Block>
    );
};
